// Project
import { putCaseData } from 'src/lib/fetch';

export const unlockSignIn = async (email: string) => {
  const result = await putCaseData(`/signin-blocked-users/${email}`, {});
  return result;
};
